import { createSelector } from "reselect"
import { getIsActive, getBaseStartDate } from "./base"
import { getStartDate, getLatestDate } from "./dates"
import { getUnmodeledDates } from "selectors/dates"
import { getNextModeledDate } from "helpers/dates"
import { getSelectedScreen, getSelectedSubScreen } from "."

export const getPerformanceFetchStartDate = createSelector(
  [getSelectedScreen, getSelectedSubScreen, getStartDate, getBaseStartDate, getIsActive, getUnmodeledDates, getLatestDate],
  (selectedScreen, selectedSubScreen, startDate, baseStartDate, isActive, unmodeledDates, latestDate) => {
    if (!(selectedScreen === "factors" && selectedSubScreen === "performance")) { return undefined }
    if (isActive && baseStartDate && startDate <= baseStartDate) {
      return getNextModeledDate(baseStartDate, latestDate, unmodeledDates)
    }

    return startDate
  },
)
